var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadPhotoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5429_40536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1585 14.8937C18.1585 15.2931 17.9998 15.6762 17.7174 15.9586C17.435 16.241 17.052 16.3996 16.6526 16.3996H3.09963C2.70025 16.3996 2.31722 16.241 2.03481 15.9586C1.75241 15.6762 1.59375 15.2931 1.59375 14.8937V6.61139C1.59375 6.212 1.75241 5.82897 2.03481 5.54657C2.31722 5.26416 2.70025 5.1055 3.09963 5.1055H6.1114L7.61728 2.84668H12.1349L13.6408 5.1055H16.6526C17.052 5.1055 17.435 5.26416 17.7174 5.54657C17.9998 5.82897 18.1585 6.212 18.1585 6.61139V14.8937Z",
    stroke: "white",
    strokeWidth: 0.903529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87505 13.3878C11.5384 13.3878 12.8868 12.0394 12.8868 10.376C12.8868 8.71267 11.5384 7.36426 9.87505 7.36426C8.21169 7.36426 6.86328 8.71267 6.86328 10.376C6.86328 12.0394 8.21169 13.3878 9.87505 13.3878Z",
    stroke: "white",
    strokeWidth: 0.903529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5429_40536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0706,
    height: 18.0706,
    fill: "white",
    transform: "translate(0.839844 0.587891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhotoIcon);
export default __webpack_public_path__ + "static/media/upload-photo-icon.e9479376ba8eca9bec45adc065018240.svg";
export { ForwardRef as ReactComponent };